import React, { useState } from "react";
import {
    Card,
    Typography,
    Button,
    Space,
    message,
    Tag,
    theme as antdTheme,
} from "antd";
import { getBackendUrl } from "../../utils/env";
import axios from "axios";
import {
    GiftFilled,
    FireFilled,
    CheckCircleFilled,
} from "@ant-design/icons";

import { useNavigate } from "react-router-dom";

const { Title, Text, Paragraph } = Typography;

export default function Aniversario() {
    const navigate = useNavigate();
    const { token } = antdTheme.useToken();

    const bravoColor = "#FFB800";

    const [abierto, setAbierto] = useState(false);
    const [reclamando, setReclamando] = useState(false);
    const [yaReclamo, setYaReclamo] = useState(false);
    const [intentoTrampa, setIntentoTrampa] = useState(false);
    const [nombreUsuario, setNombreUsuario] = useState("");


    const reclamarRegalo = async () => {
        // Barrera visual adicional
        if (yaReclamo || reclamando) {
            message.warning({
                content: "😏 Ese regalo ya te lo llevaste. No seas gandalla.",
                duration: 3,
            });
            return;
        }

        const userId =
            localStorage.getItem("user_id") ||
            sessionStorage.getItem("user_id");

        const nombre =
            localStorage.getItem("name") ||
            sessionStorage.getItem("name") ||
            "Alguien";

        setNombreUsuario(nombre);

        try {
            setReclamando(true);

            const response = await axios.post(
                `${getBackendUrl()}api/anniversary.php?id=${userId}`
            );

            // 🎉 REGALO ENTREGADO
            if (response.data.success) {
                setYaReclamo(true);
                setAbierto(true);

                message.success({
                    content: "🎉 ¡200 Bravos desbloqueados!",
                    duration: 4,
                });

                return;
            }

            // 😏 YA LO HABÍA RECLAMADO
            if (response.data.already_claimed) {
                setIntentoTrampa(true);
                setNombreUsuario(nombre || "Alguien");
                message.warning({
                    content: "😏 A ver... ese regalo ya te lo llevaste." + (nombre || "Alguien"),
                    duration: 3,
                });

                return;
            }

        } catch (error) {
            console.error(
                "Error al reclamar regalo:",
                error.response?.data || error
            );

            // Por si el backend devuelve 409
            if (error.response?.data?.already_claimed) {
                setIntentoTrampa(true);

                message.warning({
                    content: "😏 Buen intento...",
                    duration: 3,
                });

                return;
            }

            message.error(
                "No se pudo reclamar el regalo. Inténtalo nuevamente."
            );

        } finally {
            setReclamando(false);
        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "32px 20px",
                background: `radial-gradient(
                circle at 50% 0%,
                ${bravoColor}18,
                transparent 45%
            )`,
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* =========================================================
            DECORACIONES
        ========================================================== */}

            <div
                style={{
                    position: "absolute",
                    top: "8%",
                    left: "8%",
                    fontSize: 60,
                    opacity: 0.08,
                    transform: "rotate(-15deg)",
                }}
            >
                🎉
            </div>

            <div
                style={{
                    position: "absolute",
                    top: "15%",
                    right: "10%",
                    fontSize: 70,
                    opacity: 0.08,
                    transform: "rotate(15deg)",
                }}
            >
                🎂
            </div>

            <div
                style={{
                    position: "absolute",
                    bottom: "10%",
                    left: "15%",
                    fontSize: 55,
                    opacity: 0.06,
                }}
            >
                🔥
            </div>

            <div
                style={{
                    position: "absolute",
                    bottom: "15%",
                    right: "12%",
                    fontSize: 55,
                    opacity: 0.06,
                }}
            >
                🚀
            </div>

            {/* =========================================================
            CARD PRINCIPAL
        ========================================================== */}

            <Card
                style={{
                    width: "100%",
                    maxWidth: 650,
                    borderRadius: 32,
                    textAlign: "center",
                    border: `1px solid ${bravoColor}35`,
                    background: token.colorBgContainer,
                    boxShadow: `0 25px 80px ${bravoColor}18`,
                    overflow: "hidden",
                }}
                styles={{
                    body: {
                        padding: "clamp(30px, 6vw, 55px)",
                    },
                }}
            >

                {/* =====================================================
                1. INTENTO DE RECLAMAR NUEVAMENTE
            ====================================================== */}

                {intentoTrampa ? (
                    <Space
                        direction="vertical"
                        size={24}
                        style={{
                            width: "100%",
                        }}
                    >

                        {/* 👀 DETECCIÓN */}

                        <div
                            style={{
                                fontSize: "clamp(80px, 18vw, 130px)",
                                lineHeight: 1,
                                animation: "float 3s ease-in-out infinite",
                            }}
                        >
                            👀
                        </div>

                        <Tag
                            color="red"
                            style={{
                                borderRadius: 999,
                                padding: "6px 14px",
                                fontWeight: 800,
                                fontSize: 13,
                            }}
                        >
                            🚨 INTENTO DETECTADO
                        </Tag>

                        {/* NOMBRE */}

                        <Title
                            level={1}
                            style={{
                                margin: 0,
                                fontWeight: 900,
                                fontSize: "clamp(28px, 6vw, 42px)",
                            }}
                        >
                            ¡{nombreUsuario} ha sido detectado! 👀
                        </Title>

                        <Paragraph
                            style={{
                                fontSize: 17,
                                color: token.colorTextSecondary,
                                margin: 0,
                            }}
                        >
                            Intentando reclamar el regalo{" "}
                            <strong>por segunda vez...</strong>
                        </Paragraph>

                        {/* MENSAJE DEL PROGRAMADOR */}

                        <div
                            style={{
                                padding: "26px 20px",
                                borderRadius: 24,
                                background: `linear-gradient(
                    135deg,
                    ${bravoColor}15,
                    ${bravoColor}05
                )`,
                                border: `1px solid ${bravoColor}45`,
                                width: "100%",
                            }}
                        >

                            <div
                                style={{
                                    fontSize: 45,
                                    marginBottom: 12,
                                }}
                            >
                                🧐
                            </div>

                            <Text
                                strong
                                style={{
                                    display: "block",
                                    fontSize: 19,
                                }}
                            >
                                ¿De verdad pensaste que el programador
                                no iba a darse cuenta?
                            </Text>

                            <Text
                                type="secondary"
                                style={{
                                    display: "block",
                                    marginTop: 10,
                                    fontSize: 14,
                                }}
                            >
                                El regalo solamente se puede reclamar
                                <strong> una vez</strong>.
                            </Text>

                        </div>

                        {/* EVIDENCIA */}

                        <div
                            style={{
                                padding: "14px 18px",
                                borderRadius: 16,
                                background: token.colorFillAlter,
                                width: "100%",
                            }}
                        >
                            <Text
                                type="secondary"
                                style={{
                                    fontSize: 12,
                                }}
                            >
                                🔎 EVIDENCIA DEL SISTEMA
                            </Text>

                            <div
                                style={{
                                    marginTop: 5,
                                    fontWeight: 800,
                                }}
                            >
                                Usuario: {nombreUsuario}
                            </div>

                            <div
                                style={{
                                    fontSize: 12,
                                    color: token.colorTextSecondary,
                                    marginTop: 3,
                                }}
                            >
                                🎁 Bonificación de aniversario: YA RECLAMADA
                            </div>
                        </div>

                        {/* BRAVOS */}

                        <div
                            style={{
                                fontSize: 13,
                                color: token.colorTextSecondary,
                            }}
                        >
                            🔥 Tus +100 Bravos ya están en tu cuenta.
                        </div>

                        <Button
                            size="large"
                            onClick={() => setIntentoTrampa(false)}
                            style={{
                                borderRadius: 14,
                                fontWeight: 700,
                            }}
                        >
                            Bueno, ya entendí 😂
                        </Button>

                    </Space>

                ) : abierto ? (

                    /* =====================================================
                       2. REGALO YA ABIERTO
                    ====================================================== */

                    <Space
                        direction="vertical"
                        size={22}
                        style={{
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                fontSize: "clamp(75px, 18vw, 130px)",
                                lineHeight: 1,
                                animation: "float 3s ease-in-out infinite",
                            }}
                        >
                            🎉
                        </div>

                        <Tag
                            color="green"
                            style={{
                                borderRadius: 999,
                                padding: "6px 14px",
                                fontWeight: 700,
                            }}
                        >
                            ✓ REGALO RECLAMADO
                        </Tag>

                        <Title
                            level={1}
                            style={{
                                margin: 0,
                                fontWeight: 900,
                            }}
                        >
                            ¡REGALO DESBLOQUEADO!
                        </Title>

                        <Paragraph
                            style={{
                                fontSize: 16,
                                color: token.colorTextSecondary,
                                margin: 0,
                            }}
                        >
                            El programador cumplió su palabra. 😎
                            <br />
                            <strong>
                                Y esos Bravos ya son tuyos.
                            </strong>
                        </Paragraph>

                        {/* BRAVOS */}

                        <div
                            style={{
                                padding: "28px 20px",
                                borderRadius: 24,
                                background: `linear-gradient(
                                135deg,
                                ${bravoColor}18,
                                ${bravoColor}05
                            )`,
                                border: `1px solid ${bravoColor}45`,
                            }}
                        >
                            <FireFilled
                                style={{
                                    fontSize: 30,
                                    color: "#FF6B35",
                                }}
                            />

                            <div
                                style={{
                                    fontSize: "clamp(52px, 12vw, 76px)",
                                    lineHeight: 1.1,
                                    fontWeight: 900,
                                    color: bravoColor,
                                }}
                            >
                                +100
                            </div>

                            <Text
                                strong
                                style={{
                                    fontSize: 19,
                                }}
                            >
                                BRAVOS
                            </Text>

                            <div
                                style={{
                                    marginTop: 10,
                                }}
                            >
                                <Tag color="gold">
                                    🎂 Bonificación de aniversario
                                </Tag>
                            </div>
                        </div>

                        <Paragraph
                            style={{
                                color: token.colorTextSecondary,
                                margin: 0,
                            }}
                        >
                            Gracias por haber sido parte del primer año de
                            Sentinel. ❤️
                        </Paragraph>

                        <Button
                            size="large"
                            onClick={() => navigate("/dashboard")}
                            style={{
                                borderRadius: 14,
                                fontWeight: 700,
                            }}
                        >
                            Volver al Dashboard
                        </Button>
                    </Space>

                ) : (

                    /* =====================================================
                       3. REGALO DISPONIBLE
                    ====================================================== */

                    <Space
                        direction="vertical"
                        size={24}
                        style={{
                            width: "100%",
                        }}
                    >
                        <Tag
                            color="gold"
                            style={{
                                fontSize: 13,
                                fontWeight: 800,
                                padding: "6px 14px",
                                borderRadius: 999,
                                border: "none",
                            }}
                        >
                            🎉 EDICIÓN ANIVERSARIO
                        </Tag>

                        <div
                            style={{
                                fontSize: "clamp(70px, 15vw, 110px)",
                                lineHeight: 1,
                                animation: "float 3s ease-in-out infinite",
                            }}
                        >
                            🎁
                        </div>

                        <Title
                            level={1}
                            style={{
                                margin: 0,
                                fontSize: "clamp(32px, 7vw, 48px)",
                                fontWeight: 900,
                            }}
                        >
                            ¡Hay algo para ti!
                        </Title>

                        <Paragraph
                            style={{
                                fontSize: 17,
                                color: token.colorTextSecondary,
                                margin: 0,
                            }}
                        >
                            Sentinel cumple su{" "}
                            <strong
                                style={{
                                    color: bravoColor,
                                }}
                            >
                                primer aniversario
                            </strong>
                            .
                        </Paragraph>

                        <Paragraph
                            style={{
                                fontSize: 16,
                                margin: 0,
                            }}
                        >
                            Y como el programador tiene demasiado poder...
                            <br />
                            decidió regalarte algo. 😏
                        </Paragraph>

                        {/* PREMIO */}

                        <div
                            style={{
                                padding: "22px",
                                borderRadius: 22,
                                background: `${bravoColor}10`,
                                border: `1px dashed ${bravoColor}60`,
                            }}
                        >
                            <Text
                                type="secondary"
                                style={{
                                    display: "block",
                                    fontSize: 13,
                                }}
                            >
                                TU REGALO DE ANIVERSARIO
                            </Text>

                            <div
                                style={{
                                    fontSize: "clamp(42px, 10vw, 64px)",
                                    fontWeight: 900,
                                    color: bravoColor,
                                    lineHeight: 1.2,
                                    marginTop: 5,
                                }}
                            >
                                +100
                            </div>

                            <div
                                style={{
                                    fontWeight: 800,
                                    fontSize: 18,
                                }}
                            >
                                🔥 BRAVOS
                            </div>
                        </div>

                        {/* BOTÓN */}

                        <Button
                            type="primary"
                            size="large"
                            icon={<GiftFilled />}
                            loading={reclamando}
                            disabled={reclamando}
                            onClick={reclamarRegalo}
                            style={{
                                width: "100%",
                                maxWidth: 360,
                                height: 58,
                                borderRadius: 16,
                                background: bravoColor,
                                borderColor: bravoColor,
                                color: "#000",
                                fontWeight: 900,
                                fontSize: 17,
                                boxShadow: `0 10px 25px ${bravoColor}45`,
                            }}
                        >
                            {reclamando
                                ? "ABRIENDO REGALO..."
                                : "ABRIR MI REGALO 🎁"}
                        </Button>

                        <Text
                            type="secondary"
                            style={{
                                fontSize: 12,
                            }}
                        >
                            ⚠️ Solo puedes reclamar este regalo una vez.
                        </Text>
                    </Space>
                )}
            </Card>

            {/* =========================================================
            ANIMACIÓN
        ========================================================== */}

            <style>
                {`
                @keyframes float {
                    0%, 100% {
                        transform: translateY(0);
                    }

                    50% {
                        transform: translateY(-10px);
                    }
                }
            `}
            </style>
        </div>
    );
}